import type {
  ContractRecordMap,
  PlannableOverlapExtended
} from '@libs/data-access/entities'
import type { FC } from 'react'

import { DayFields } from '../DayFields/DayFields'
import { HourFields } from '../HourFields/HourFields'

const HOUR = 'hour'
const DAY = 'day'

type Props = {
  restIsLocked: boolean
  restTypeType?: string
  disableCustomRest: boolean
  plannableOverlapExtended: PlannableOverlapExtended
  contracts: ContractRecordMap
}

export const DurationFields: FC<Props> = ({
  contracts,
  restTypeType,
  restIsLocked,
  plannableOverlapExtended,
  disableCustomRest
}) => {
  return (
    <div>
      {restTypeType === HOUR && <HourFields disabled={restIsLocked} />}

      {restTypeType === DAY && (
        <DayFields
          plannableOverlapExtended={plannableOverlapExtended}
          contracts={contracts}
          restIsLocked={restIsLocked}
          disableCustomRest={disableCustomRest}
        />
      )}
    </div>
  )
}
